module.exports = __webpack_public_path__ + "static/assets/b8c58b160051ad14a948bce004de1f24.png";